import type { CSSProperties } from 'preact'

import type {
  CookieCategory,
  CookieRecord,
} from '../../../../services/cookieTranslationService/types'

import { getCookieDomainFromWebsiteUrl } from '#src/assets/core/consentConfig.ts'
import type { CookieConsentTranslator } from '#src/assets/lib/i18n.ts'
import { NecessaryCookiesSection } from '#src/assets/ui/overview/components/NecessaryCookiesSection.tsx'
import { PolicySection } from '#src/assets/ui/overview/components/PolicySection.tsx'
import type { SiteConfig } from '#src/models/site-configs/siteConfigs.ts'

export function CookieOverview({
  t,
  locale,
  siteConfig,
  cookiesByCategory,
}: {
  t: CookieConsentTranslator
  locale: string
  siteConfig: SiteConfig
  cookiesByCategory: Record<CookieCategory, Array<CookieRecord>>
}) {
  const cookieDomain = getCookieDomainFromWebsiteUrl(siteConfig.domain)

  return (
    <div style={bodyStyle}>
      <PolicySection
        t={t}
        locale={locale}
        siteConfig={siteConfig}
        cookiesByCategory={cookiesByCategory}
      />
      <NecessaryCookiesSection
        t={t}
        cookies={cookiesByCategory.necessary}
        cookieDomain={cookieDomain}
      />
    </div>
  )
}

const bodyStyle: CSSProperties = {
  padding: '0 1.5rem 0.75rem',
  display: 'flex',
  flexDirection: 'column',
  gap: '0.5rem',
  flex: '1',
  minHeight: '0',
  minWidth: '0',
  overflowY: 'auto',
  overflowX: 'hidden',
}
